import { useLang } from "@/lang";

export function CertBadges({ tone = "light" }) {
    const { c } = useLang();
    return (
        <div className="flex flex-wrap items-center justify-center gap-4">
            {c.certs.badges.map((b, i) => (
                <div
                    key={b.mark}
                    data-testid={`cert-badge-${i + 1}`}
                    className={`flex h-20 w-24 flex-col items-center justify-center gap-1 rounded-2xl border ${
                        tone === "dark" ? "border-paper/30 bg-paper/5" : "border-line bg-pure"
                    }`}
                >
                    <span
                        className={`font-display text-xl font-extrabold tracking-tight ${
                            tone === "dark" ? "text-paper" : "text-ink"
                        }`}
                    >
                        {b.mark}
                    </span>
                    <span
                        className={`font-mono text-[8px] uppercase tracking-[0.3em] ${
                            tone === "dark" ? "text-paper/50" : "text-mist"
                        }`}
                    >
                        {b.sub}
                    </span>
                </div>
            ))}
        </div>
    );
}
